export const REDUCER_NAME = 'display'




// WEBPACK FOOTER //
// ./src/modules/invoice/state/display/const.js